import React, {useState, useEffect} from "react";
import {FormGroup, Button, Form, Input, InputGroupAddon, InputGroupText, InputGroup, Modal, Badge, Card, CardBody, CardTitle, CardHeader, CardFooter, Col, DropdownMenu, DropdownItem, UncontrolledDropdown, DropdownToggle, Media, Nav, NavItem, NavLink, Pagination, PaginationItem, PaginationLink, Progress, Table, Container, Row, UncontrolledTooltip, Dropdown, } from "reactstrap";
import { DateRangePicker } from 'react-date-range';
import { addDays } from 'date-fns';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const DateRangeModal = ({open, toggle, dateRange, setRange, filter_fn}) => {
	const [initialised, set_initialised] = useState(false);
	const [tempRange, setTempRange] = useState([{
													startDate: new Date(),
													endDate: addDays(new Date(), 7),
													key: 'selection'
												}]);

												
	const onclick_submit = () => {
        let dRange = tempRange[0];
        dRange.startDate = dayjs(dRange.startDate)
        dRange.endDate = dayjs(dRange.endDate)
        dRange.startDate = dRange.startDate.set('hour', 0); dRange.startDate = dRange.startDate.set('minute', 0); dRange.startDate = dRange.startDate.set('second', 0)
        dRange.endDate = dRange.endDate.set('hour', 23); dRange.endDate = dRange.endDate.set('minute', 59); dRange.endDate = dRange.endDate.set('second', 59)
        dRange.startDate = dayjs(dRange.startDate).utc(true).toDate()
        dRange.endDate = dayjs(dRange.endDate).utc(true).toDate()
		if(filter_fn) filter_fn(dRange.startDate, dRange.endDate)
		setRange(dRange.startDate, dRange.endDate)
		onClick_handleClose()
	}					
	
	const onClick_handleClose = () => {
		toggle()
	}

	useEffect(() => {
		if(open && dateRange && !initialised) {
			setTempRange(dateRange)
			set_initialised(true);
		}
	}, [open, dateRange]);
	
	return(
		<Modal className="modal-dialog-centered" size="lg" isOpen={open} toggle={onClick_handleClose}>
			<div className="modal-body  bg-gradient-secondary" style={{fontSize:'14px', width:'938px'}}>
				<DateRangePicker
					onChange={item => {setTempRange([item.selection])}}
					showSelectionPreview={true}
					moveRangeOnFirstSelection={false}
					months={2}
					ranges={tempRange}
					direction="horizontal"
				/>
			</div>
			<div className="modal-footer" style={{height:'60px', width:'938px', backgroundColor:'white'}}>
				<Button color='primary' onClick={onclick_submit}>Submit</Button>
			</div>
		</Modal>
	)
}

export default DateRangeModal